import "whatwg-fetch";

// point the URL to localhost if running docker container from local machine
//const REST_URL = "http://localhost:8080";
//const REST_URL = "https://dev.techlearningzone.com";
const REST_URL = "https://runtime.techlearningzone.com";

const getToken = () => {
  const tkn = localStorage.getItem("tkn");
  return tkn;
};

export async function CheckUser(userID) {
  console.log("CheckUser API -> userID: ", userID);

  try {
    const response = await fetch(`${REST_URL}/checkUser/${userID}`);
    const json = await response.json();

    //console.log("result: ", JSON.stringify(json));
    return {
      output: json,
      status: response.status
    };
  } catch (error) {
    console.log("CheckUSer API error: " + JSON.stringify(error));
    return {
      error: error,
      status: "404"
    };
  }
}

export async function CreateUser(userID, pswd, programID) {
  let data = {
    userid: userID,
    password: pswd,
    programid: programID || "javascript"
  };

  try {
    const response = await fetch(`${REST_URL}/createUser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    const json = await response.json();
    //console.log("result: ", JSON.stringify(json));

    return {
      output: json,
      status: response.status
    };
  } catch (error) {
    console.log("CreateUSer API error: " + JSON.stringify(error));

    return {
      error: error,
      status: "500"
    };
  }
}

export async function UpdateViewStats(userID, programID) {
  // console.log("UpdateViewStats API -> userID: ", userID);
  // console.log("UpdateViewStats API -> programID: ", programID);

  let data = {
    userid: userID,
    programid: programID || "javascript"
  };

  try {
    //const response = await fetch(`${REST_URL}/updateViewStats`, {
    const response = await fetch(`${REST_URL}/updateViewStats/${userID}`, {
      method: "POST",
      // withCredentials: true,
      // credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getToken()
      },
      body: JSON.stringify(data)
    });
    // const json = await response.json();
    // console.log("updateViewStats result: ", JSON.stringify(json));
    const result = await response.text();
    console.log("updateViewStats result: ", result);

    return {
      output: result,
      status: response.status
    };
  } catch (error) {
    console.log("UpdateViewStats API error: " + JSON.stringify(error));

    return {
      error: error,
      status: "500"
    };
  }
}
